import { HTTP } from '../../http';

const state = {
  currentVehicle: JSON.parse(localStorage.getItem('exideVehicle')) || null,
  newVehicleCreated: false,
  newVehicleCreateErrors: false
};

const mutations = {
  SET_CURRENT_VEHICLE(state, data) {
    state.currentVehicle = data;
    localStorage.setItem('exideVehicle', JSON.stringify(data));
  },
  SET_NEW_VEHICLE_CREATED(state, data) {
    state.newVehicleCreated = data;
  },
  SET_NEW_VEHICLE_CREATE_ERRORS(state, data) {
    state.newVehicleCreateErrors = data;
  }
};

const getters = {
  getNewVehicleCreated: state => state.newVehicleCreated,
  getNewVehicleCreateErrors: state => state.newVehicleCreateErrors,
  getCurrentVehicle: state => state.currentVehicle
};

const actions = {
  createVehicleByPlatesOrVin: ({ commit }, payload) => {
    return HTTP.post('/api/set-car-plates-or-vin', payload)
      .then(response => {
        commit('SET_CURRENT_VEHICLE', response.data.vehicleData);
        commit('SET_NEW_VEHICLE_CREATED', true);
        return response;
      })
      .catch(error => {
        commit('SET_NEW_VEHICLE_CREATE_ERRORS', error.response.data);
        commit('SET_NEW_VEHICLE_CREATED', false);
        throw error.response;
      });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
